export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-7.cf39a174.jpg";